import { useState, useEffect } from 'react';
// import { getMenuList } from '../services/adminApiService/menuApi/MenuApiService';

export const useMenu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        setLoading(true);
        // const response = await getMenuList();
        
        // if (response?.data?.status && response?.data?.data) {
        //   const formattedMenu = transformMenuData(response.data.data);
        //   setMenuItems(formattedMenu);
        // } else {
        //   setMenuItems([]);
        // }
      } catch (err) {
        console.error('Error fetching menu:', err);
        setError(err.message);
        setMenuItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);

  return { menuItems, loading, error };
};

const transformMenuData = (apiMenuItems) => {
  return apiMenuItems.map((item) => {
    const menuItem = {
      title: item.title,
      classsChange: item.has_arrow || (item.children && item.children.length > 0) ? 'mm-collapse' : '',
      iconStyle: item.icon ? <i className={item.icon}></i> : null,
      to: item.url || '#',
    };

    if (item.children && item.children.length > 0) {
      menuItem.content = item.children.map((child) => ({
        title: child.title,
        to: child.url || '#',
        iconStyle: child.icon ? <i className={child.icon}></i> : null,
      }));
    }

    return menuItem;
  });
};

